import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { EXPERIMENTS, FIELD_TYPES } from '../../../constants';
import { SignatureFieldWUT } from '../../../ui/signature-field/signature-field-wut';
import { SignatureFieldWUT as SignatureFieldWUTv2 } from '../../../ui/signature-field-v2/signature-field-wut';
import { useExperiments } from '../../../contexts/experiments-context';
export function SignatureWUT(props) {
  const {
    fieldType = FIELD_TYPES.SIGNATURE
  } = props;
  const v2 = useExperiments().isExperimentEnabled(EXPERIMENTS.SIGNATURE_FIELD_V2);
  if (v2) {
    return /*#__PURE__*/React.createElement(SignatureFieldWUTv2, _extends({}, props, {
      fieldType: fieldType
    }));
  }
  return /*#__PURE__*/React.createElement(SignatureFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
}
//# sourceMappingURL=signature-wut.js.map